import React from 'react';
import styled from 'styled-components';
import {
   TscThemeName,
   TscThemeNames,
   TscStyles
} from '@techsmith/tsc-cloud-style-guide';
import cssConstants from '../../constants/cssConstants';

const UpdateContainer = styled.div<{theme: TscThemeNames}>`
    display: flex;
    flex-direction: column;
    margin-top: 1rem;
    justify-content: flex-start;
    width: 100%;
    box-sizing: border-box;
    color: ${props => props.theme === TscThemeName.dusk ? TscStyles.color.text.light : TscStyles.color.text.mediumDark};
`;

const UpdateDate = styled.div<{theme: TscThemeNames}>`
   display: flex;
   flex-direction: column;
   font-size: 1.125rem;
   line-height: 1.6875rem;
   font-weight: 600;
   color: ${props => props.theme === TscThemeName.dusk ? TscStyles.color.text.light : TscStyles.color.text.mediumDark};
   @media screen and (max-width: ${cssConstants.whatsNewMobileBreakpoint}px) {
      font-size: 1rem;
   };
`;

const WhatsNewUpdateGroup: React.FC<IProps> = ({theme, date, children}) => (
   <UpdateContainer theme={theme}>
      <UpdateDate theme={theme}>
         {date}
      </UpdateDate>
      {children}
   </UpdateContainer>
);

interface IProps {
   theme: TscThemeNames;
   date: string;
   children?: React.ReactNode | React.ReactNode[];
}

export default WhatsNewUpdateGroup;